import React, { useState } from "react";
import { Box } from "@mui/material";
import Select, { TOption } from "../../../Components/Select";
import TimePicker from "../../../Components/TimePicker";
import { TSunTrigger } from "./types";
import { useTranslation } from "react-i18next";

interface ISunTriggerFormProps {
  trigger: TSunTrigger;
  onChange: (timeTrigger: TSunTrigger) => void;
}

const SunTriggerForm = (props: ISunTriggerFormProps) => {
  const { trigger, onChange } = props;
  const [sunTrigger, setSunTrigger] = useState<TSunTrigger>(trigger);
  const { t } = useTranslation();

  const eventOptions: TOption<string>[] = [
    { value: "sunrise", label: t("Sunrise") },
    { value: "sunset", label: t("Sunset") },
  ];

  const handleChange = (key: string, value: string) => {
    const newSunTrigger = { ...sunTrigger, [key]: value };
    setSunTrigger(newSunTrigger);
    onChange(newSunTrigger);
  };

  return (
    <Box gap={1} display="flex" flexDirection="row">
      <Select
        label={t("Event")}
        options={eventOptions}
        value={trigger.event}
        onChange={(event) => handleChange("event", event.target.value)}
        sx={{ width: "50%" }}
        margin="none"
        data-cy="sun-trigger-select-event"
      />
      <TimePicker
        label={t("Offset")}
        value={trigger.offset}
        isSigned={true}
        onTimeChange={(time: string) => handleChange("offset", time)}
        sx={{ width: "50%" }}
        data-cy="sun-trigger-offset-picker"
      />
    </Box>
  );
};

export default SunTriggerForm;
